import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { NotaFilter } from '../filter';
import { NotaSearch } from '../nota-search';

@Injectable({
    providedIn: 'root'
})
export class NotaSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/nota`;
    }

    /** Realizada a pesquisa das notas */
    search(filter: NotaFilter, offset: number, limit: number): Observable<NotaSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<NotaSearch[]>(this.pathApi, {params});
    }

    /** Pesquisa uma única nota através do ID informado */
    searchOne(idNota: number): Observable<NotaSearch> {
        return this.customHttp.get<NotaSearch>(`${this.pathApi}/${idNota}/search`);
    }
}
